import { userInfoSync } from 'hub-http/userInfo';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const CJC0001_EXPERIMENT_KEY = 'cjc-0001';
const CJC0001_TASK_COMPANION_GATE = 'CJComponents:CJC-0001:TaskCompanion';
const EXPERIMENT_GROUP_OVERRIDE_KEY = 'cjc-0001-group-override';
const TREATMENTS_ENDPOINT = 'treatments/v3/get';
function getOverrideGroup() {
  try {
    const overrideValue = localStorage.getItem(EXPERIMENT_GROUP_OVERRIDE_KEY);
    if (overrideValue === 'variation' || overrideValue === 'control') {
      return overrideValue;
    }
  } catch (_unused) {
    // localStorage may be unavailable
  }
  return null;
}
export function persistQueryParamOverride() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParamOverride = urlParams.get(EXPERIMENT_GROUP_OVERRIDE_KEY);
    if (queryParamOverride === 'variation' || queryParamOverride === 'control') {
      localStorage.setItem(EXPERIMENT_GROUP_OVERRIDE_KEY, queryParamOverride);
    } else if (queryParamOverride === 'clear') {
      localStorage.removeItem(EXPERIMENT_GROUP_OVERRIDE_KEY);
    }
  } catch (_unused2) {
    // localStorage may be unavailable
  }
}
function isUngatedToCJC0001() {
  try {
    var _userInfoSync;
    const gates = ((_userInfoSync = userInfoSync()) === null || _userInfoSync === void 0 ? void 0 : _userInfoSync.gates) || [];
    return gates.includes(CJC0001_TASK_COMPANION_GATE);
  } catch (_unused3) {
    return false;
  }
}
function extractGroupFromTreatments(treatments) {
  const treatment = treatments.find(t => t.key === CJC0001_EXPERIMENT_KEY);
  if (!treatment) {
    return 'control';
  }
  const groupParam = treatment.parameters.find(p => p.key === 'group');
  return (groupParam === null || groupParam === void 0 ? void 0 : groupParam.value) || 'control';
}

/**
 * Adding laboratory-lib involved adding dependencies that increased the bundle
 * size more than was acceptable for onboarding-tours.
 * Thus, we're directly fetching the experiment treatment via the API.
 */

function fetchExperimentTreatment(callback) {
  const portalId = PortalIdParser.get();
  const apiDomain = getFullUrl('api');
  noAuthApiClient.post(`${apiDomain}/${TREATMENTS_ENDPOINT}`, {
    data: {
      requests: [{
        key: CJC0001_EXPERIMENT_KEY,
        identifier: String(portalId)
      }],
      identifiers: {
        PORTAL_ID: portalId
      }
    }
  }).then(treatments => {
    callback(extractGroupFromTreatments(treatments));
  }).catch(() => {
    callback('control');
  });
}
export function resolveCompanionTreatment(callback) {
  const overrideGroup = getOverrideGroup();
  if (overrideGroup) {
    callback(overrideGroup);
    return;
  }
  if (!isUngatedToCJC0001()) {
    callback('control');
    return;
  }
  fetchExperimentTreatment(callback);
}